const searchClient = algoliasearch(
    'XJ8JV9WLJ4',
    '142ecd0ffe6ef3747b653fb1e499b8af'
);

const search = instantsearch({
  indexName: 'shopify_products', // your Algolia products index name
  searchClient,
});
	
search.addWidgets([
  instantsearch.widgets.searchBox({
    container: '#search_input_ecom, #Search', // update this selector to match your search page
  }),

  instantsearch.widgets.hits({
    container: 'search', // update this selector to match your search page
  })
]);

search.start();